import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const ApiError = BaseErrorSchema.extend({
  errorType: z.literal('ApiError'),
  statusCode: z.number(),
  errorReason: z.string(),
});

export type ApiError = z.infer<typeof ApiError>;

export const isApiError = (error: unknown): error is ApiError => {
  return ApiError.safeParse(error).success;
};
